import React from 'react';
import { Typography, List, ListItem, ListItemText, Button, Box, IconButton, ListItemAvatar, Avatar, Divider, Paper } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

function ShoppingCart({ cart, totalCost, removeFromCart, clearCart, handleCheckout }) {
  const handleRemoveFromCart = (index) => {
    if (window.confirm('Are you sure you want to remove this item from your cart?')) {
      removeFromCart(index);
    }
  };

  const handleClearCart = () => {
    if (window.confirm('Are you sure you want to clear your cart?')) {
      clearCart();
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, mt: 4 }}>
      
      <List>
        {cart.map((item, index) => {
          return (
            <React.Fragment key={index}>
              <ListItem secondaryAction={<IconButton edge="end" aria-label="delete" onClick={() => handleRemoveFromCart(index)}><DeleteIcon /></IconButton>}>
                <ListItemAvatar>
                  <Avatar sx={{ width: 120, height: 120, mr: 2, backgroundColor: 'transparent' }} variant="square">
                    <img src={`/photos/thumb/${encodeURIComponent(item.thumbnail_filename)}`} alt={item.original_name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={item.raceName}
                  secondary={currencyFormatter.format(item.price)}
                />
              </ListItem>
              {index < cart.length - 1 && <Divider variant="inset" component="li" />}
            </React.Fragment>
          );
        })}
      </List>
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" component="p">
          Total: ${totalCost.toFixed(2)}
        </Typography>
        <Box>
          <Button variant="outlined" color="error" onClick={handleClearCart} sx={{ mr: 2 }}>
            Clear Cart
          </Button>
          <Button variant="contained" color="primary" size="large" onClick={handleCheckout}>
            Checkout
          </Button>
        </Box>
      </Box>
    </Paper>
  );
}

export default ShoppingCart;
